export default "__VITE_ASSET__3d058685__"